import client from '../../../common/client';

export const GET_LIBRARY = 'GET_LIBRARY';

export const getLibrary = () => ({
  promise: client.get('library/categories/active', null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_LIBRARY,
});



// WEBPACK FOOTER //
// ./src/subscription/library/redux/actions.js